"use client";

import { useEffect } from "react";

import { registerServiceWorker } from "@/lib/pwa";

/**
 * Boots the PWA once (change add-pwa-install, task 2.4): unconditional
 * service worker registration at startup so offline caching and the
 * install prompt work even if push notifications are never enabled.
 */
export function PwaBootstrap() {
  useEffect(() => {
    void registerServiceWorker();
  }, []);
  return null;
}
